@if (dataPointsForChart$ | async) {
  <app-chart-tile
    [title]="'mixit-pump-chart.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [periodOptions]="periodOptions"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
